module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0",
      "height": "auto !important"
    }
  }, [_c('van-divider', [_vm._v(_vm._s(_vm.saiqu.name) + " " + _vm._s(_vm.start.title))]), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.list), function(row, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": '#' + (index + 1) + ' ' + row.mingcheng,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectShow(row)
        }
      }
    }, [_c('template', {
      slot: "label"
    }, [_c('span', {
      staticClass: "font-size0 van-color-text-assist"
    }, [_vm._v(" " + _vm._s(row.subject_name))]), _vm._v(" "), (row.jianlu_status == 6 && row.jianlu_note) ? _c('div', {
      staticClass: "jianlu-note-line"
    }, [_vm._v(_vm._s(row.jianlu_note))]) : _vm._e()]), _vm._v(" "), [(row.jianlu_status == 0) ? _c('span', {
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v("待检录")]) : (row.jianlu_status == 4) ? _c('span', {
      staticStyle: {
        "color": "#1989fa"
      }
    }, [_vm._v("已签到")]) : (row.jianlu_status == 5) ? _c('span', {
      staticStyle: {
        "color": "#32ae57"
      }
    }, [_vm._v("检录完成")]) : (row.jianlu_status == 6) ? _c('span', {
      staticStyle: {
        "color": "#f00"
      }
    }, [_vm._v("待整改")]) : (row.jianlu_status == 7) ? _c('span', {
      staticStyle: {
        "color": "#000"
      }
    }, [_vm._v("比赛完成")]) : (row.jianlu_status == 8) ? _c('span', {
      staticStyle: {
        "color": "#c39004"
      }
    }, [_vm._v("弃权")]) : (row.jianlu_status == 9) ? _c('span', {
      staticStyle: {
        "color": "#f00"
      }
    }, [_vm._v("超时未到")]) : _vm._e()]], 2)
  }), 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.optionsShow),
      callback: function($$v) {
        _vm.optionsShow = $$v
      },
      expression: "optionsShow"
    }
  }), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "整改问题说明",
      "show-cancel-button": "",
      "confirm-button-text": "提交",
      "before-close": _vm.onJianluNoteBeforeClose
    },
    model: {
      value: (_vm.jianluNoteShow),
      callback: function($$v) {
        _vm.jianluNoteShow = $$v
      },
      expression: "jianluNoteShow"
    }
  }, [_c('div', {
    staticClass: "jianlu-note-dialog-body"
  }, [_c('van-field', {
    attrs: {
      "type": "textarea",
      "rows": "4",
      "maxlength": "500",
      "placeholder": "请输入问题内容",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.jianluNoteInput),
      callback: function($$v) {
        _vm.jianluNoteInput = $$v
      },
      expression: "jianluNoteInput"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf69ad3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/StartList.vue
// module id = 2333
// module chunks = 0